import $appConfig from "servicestack/config";
import $session from "servicestack/session";
import $pageConfig from "webutils/services/page-config";
import $labels from "servicestack/_labels";
import resolve from "ioc/resolve";
//import $geo from 'webutils/services/geo'

function noop() {}

export function $emit() {
  const $rootScope = resolve("$rootScope");
  $rootScope.$emit.apply($rootScope, arguments);
}

export function $on() {
  const $rootScope = resolve("$rootScope");
  return this.$listeners.push($rootScope.$on.apply($rootScope, arguments));
}

export function $broadcast() {
  const $rootScope = resolve("$rootScope");
  return $rootScope.$broadcast.apply($rootScope, arguments);
}

export function $rsApply() {
  const $rootScope = resolve("$rootScope");
  return $rootScope.$apply.apply($rootScope, arguments);
}

export function $onDestroy() {
  // console.warn("$onDestroy.$listeners", this.$listeners);
  this.$listeners.forEach((un) => un());
  this.$cleanUp();
  for (let key in this) {
    if (this[key] && this[key].dispose && key[0] !== "$") {
      // console.warn("$dispose", key, this[key], this);
      this[key].dispose();
    }
    delete this[key];
    // console.warn("$delete", key);
  }
  delete this.__proto__;
  // console.warn("$destroyed", this);
}

export function $cleanUp() {
  // console.warn("$cleanUp", this);
}

export default ($ctrl) => {
  // console.warn("$basic$controller", $ctrl, $ctrl.prototype);
  const $stateParams = resolve("$stateParams");
  const $state = resolve("$state");
  const $cart = resolve("$cart");
  const $notify = resolve("notify");
  const $modals = resolve("modals");
  // const $localStorage = resolve("$localStorage");
  if (!Array.isArray($ctrl.$listeners)) $ctrl.$listeners = [];
  Object.assign(
    $ctrl,
    {
      $appConfig,
      $pageConfig,
      $session,
      $labels,
      $cart,
      $state,
      $stateParams,
      $broadcast,
      $emit,
      $notify,
      $modals,
      $on,
      $rsApply,
      ["$onDestroy" + ($ctrl.$onDestroy ? "2" : "")]: $onDestroy,
      ["$cleanUp" + ($ctrl.$cleanUp ? "2" : "")]: $cleanUp,
      $ioc: resolve,
    },
    $ctrl.$resolve || {}
    //, $geo
  );

  // do not override existing $ctrl props
  for (let key in $stateParams) {
    if (!(key in $ctrl)) {
      $ctrl[key] = $stateParams[key];
    }
  }
  //console.debug("$ctrl. expanded", $ctrl)
};
